<template>
  <div class="shinsotsu">
    <router-view
      v-bind:form_data="form_data"
      v-bind:click="click"
      v-on:click_kakunin="click=true"
      v-on:removeData="remove_data"
      v-on:getId="area=$event"
    ></router-view>
  </div>
</template>
<script>
const data = {
  job: "",
  kinmuchi: [],
  name: { kanji: "", furigana: "" },
  seibetsu: "",
  age: "",
  juusyo: { yuubin_num: "", address: "" },
  tel: "",
  mail: "",
  beforCompany: "",
  zaiseki: "",
  gyoumunaiyou: "",
  ziki: { year: "", month: "" },
  question: "",
  area: "",
};
export default {
  metaInfo: {
    titleTemplate: "%s ファミリー庭園"
  },
  data() {
    return {
      form_data: JSON.parse(JSON.stringify(data)),
      click: false,
      area: "",
    };
  },
  methods: {
    remove_data() {
      localStorage.removeItem("chuto-savedata");
      this.form_data = JSON.parse(JSON.stringify(data));
      this.click = false;
    }
  },
  mounted() {
    var savedata = JSON.parse(localStorage.getItem("chuto-savedata"));
    if (savedata) {
      this.form_data = savedata;
    }
    if (this.area) {
      this.form_data.area = this.area;
    }
  },
  watch: {
    form_data: {
      handler() {
        localStorage.setItem("chuto-savedata", JSON.stringify(this.form_data));
      },
      deep: true
    }
  }
};
</script>

